export default ({
  app,
  $apiCart,
  $bugsnag,
  store
}) => {
  // default error handler
  const cartErrorHandler = error => {
    console.log('cart error handle', error)
    console.log('response', error.response)
    const code = parseInt(error.response && error.response.status, 10)
    const response = error.response

    let errorMessage = 'Unexpected error'

    if (isNaN(code)) {
      app.$toast.error(error, { icon: 'error', duration: 10000 })
      return
    }

    switch (code) {
      case 500:
        errorMessage = '*** 500 Internal Server Error. API may be down. ***'
        break

      case 400:
        errorMessage = Object.values(response.data)[0]
        if ($bugsnag) {
          $bugsnag.notify(error, function(event) {
            event.context = 'server-bad-request'
            event.addMetadata('response', response)
          })
        }
        break

      case 401:
        // app.store.dispatch('auth/logout')
        errorMessage = response.statusText
        break

      case 403:
        // app.store.dispatch('auth/logout')
        errorMessage = response.statusText
        break

      case 404:
        // Assume cart cart expired
        errorMessage = 'Cart expired'
        console.log('cart expired from 404')
        store.commit('cart/setExpired', true)
        break

      case 422:
        if (response.data.message) {
          console.log('using data message:', response.data.message)
          errorMessage = response.data.message
        } else {
          console.log('no data message')
          errorMessage = Object.values(response.data)[0]
        }
        switch (response.data.result_code) {
          case 6:
            // Cart expired
            console.log('cart expired from result code 6')
            store.commit('cart/setExpired', true)
            break
          case 10: // Product Min Limit
          case 11: // Product Max Limit
          case 15: // Variant Min Limit
          case 16: // Variant Max Limit
          case 21: // Wholesale Limit Dollars
          case 22: // Wholesale Limit Quantity
          case 30: // Bundle Corp Only
          case 40: // Bundle Unavailable
          case 41: // Item Unavailable
            // These can return response.data.message from above
            break
          case 99:
          default:
            // Unexpected error
            if ($bugsnag) {
              $bugsnag.notify(error, function(event) {
                event.context = 'server-validation-error'
                event.addMetadata('response', response)
              })
            }
            break
        }
        break
      case 423:
        // Cart is locked for processing
        errorMessage = response.data
        break
      default:
        errorMessage = response
        break
    }
    app.$toast.error(errorMessage, { icon: 'alert', duration: 10000 })
  }
  // carts api errors
  $apiCart.onError(err => cartErrorHandler(err))
}
